export default __webpack_public_path__ + "static/media/tic-tac.d5f45ff5.png";